import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, Stack, Typography } from '@mui/material';


export type AsyncConfirmationProps = {
  show?: boolean;
  title?: CVT.MaybeNull<React.ReactNode>;
  content?: CVT.MaybeNull<React.ReactNode>;
  confirmLabel?: CVT.MaybeNull<React.ReactNode>;
  cancelLabel?: CVT.MaybeNull<React.ReactNode>;
}

export type Props = AsyncConfirmationProps & {
  open?: boolean;
  onCancel?: () => void;
  onClose?: () => void;
  onConfirm?: () => void;
}

export const AsyncConfirmationDialog: React.FC<Props> = ({
  open = false,
  onClose = () => null,
  onCancel = () => null,
  onConfirm = () => null,
  title,
  content,
  confirmLabel,
  cancelLabel,
}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogContent>
      <Typography variant="body1" align="center" mb={2}>
        {title}
      </Typography>
      <Typography variant="body2" align="center" color="error">
        {content}
      </Typography>
    </DialogContent>
    <DialogActions>
      <Stack width="100%" spacing={2} direction="row" justifyContent="space-between">
        {cancelLabel && (
          <Button type="button" variant="outlined" color="primary" onClick={onCancel}>{cancelLabel}</Button>
        )}
        {confirmLabel && (
          <Button type="button" variant="contained" color="primary" onClick={onConfirm}>{confirmLabel}</Button>
        )}
      </Stack>
    </DialogActions>
  </Dialog>
);
